import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Presents Youth for God 2026 sermon and music videos from the conference archive.
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./Media.scss";
const sermons = [
    {
        title: "Христос в истории",
        type: "Sermon",
        speaker: "Балацкий Роман",
        youtubeId: "xKLiXmKJbxg",
        published: "May 28, 2026",
    },
    {
        title: "Христос - Пророк",
        type: "Sermon",
        speaker: "Нейман Константин",
        youtubeId: "HUkhuyhsts0",
        published: "May 28, 2026",
    },
];
const musicVideos = [
    {
        title: "Jesus - There's Just Something About That Name",
        type: "Music Video",
        youtubeId: "FtxesjxIH8g",
        published: "May 28, 2026",
    },
    {
        title: "Ты вошел в жизнь мою",
        type: "Music Video",
        youtubeId: "lKL5ExQV53s",
        published: "May 28, 2026",
    },
    {
        title: "Господи, услыши",
        type: "Music Video",
        youtubeId: "ZHEvi9W7sww",
        published: "May 28, 2026",
    },
    {
        title: "Ты достоин принять всю славу и честь",
        type: "Music Video",
        youtubeId: "e-vxVBHxWV0",
        published: "May 26, 2026",
    },
    {
        title: "Мне есть за что благодарить Творца",
        type: "Music Video",
        youtubeId: "CHZbMItY3L0",
        published: "May 26, 2026",
    },
    {
        title: "Разве ты не знаешь?",
        type: "Music Video",
        youtubeId: "pqLcJxnH3h8",
        published: "May 26, 2026",
    },
    {
        title: "Великий Бог!",
        type: "Music Video",
        youtubeId: "E8HwdWr8z9M",
        published: "May 26, 2026",
    },
    {
        title: "Кто приносит в жертву хвалу",
        type: "Music Video",
        youtubeId: "hnFKywbVMAU",
        published: "May 26, 2026",
    },
];
function getWatchUrl(youtubeId) {
    return `https://www.youtube.com/watch?v=${youtubeId}`;
}
function getThumbnailUrl(youtubeId) {
    return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
}
function MediaCard({ item }) {
    const meta = [item.type, item.speaker, item.published]
        .filter(Boolean)
        .join(" · ");
    return (_jsxs("article", { className: "media__card", children: [_jsxs("a", { className: "media__thumbnail-link", href: getWatchUrl(item.youtubeId), target: "_blank", rel: "noopener noreferrer", "aria-label": `Watch ${item.title} on YouTube`, children: [_jsx("img", { src: getThumbnailUrl(item.youtubeId), alt: "", loading: "lazy" }), _jsx("span", { className: "media__play", children: "Watch" })] }), _jsxs("div", { className: "media__card-body", children: [_jsx("p", { className: "media__meta", children: meta }), _jsx("h3", { children: item.title }), _jsx("a", { className: "media__watch-link", href: getWatchUrl(item.youtubeId), target: "_blank", rel: "noopener noreferrer", children: "Watch on YouTube" })] })] }));
}
function MediaSection({ title, description, items, }) {
    return (_jsxs("section", { className: "media__section", children: [_jsxs("div", { className: "media__section-header", children: [_jsx("h2", { children: title }), _jsx("p", { children: description })] }), _jsx("div", { className: "media__grid", children: items.map((item) => (_jsx(MediaCard, { item: item }, item.youtubeId))) })] }));
}
export function MediaPage() {
    return (_jsxs(_Fragment, { children: [_jsx(Header, {}), _jsxs("main", { className: "media", children: [_jsxs("section", { className: "media__hero", children: [_jsx("p", { className: "media__eyebrow", children: "Conference archive" }), _jsx("h1", { children: "2026 Conference Media" }), _jsx("p", { className: "media__lead", children: "Watch sermons and music videos from Youth for God Conference 2026, gathered from the Bible Baptist Church YouTube channel." })] }), _jsxs("div", { className: "media__content", children: [_jsx(MediaSection, { title: "Sermons", description: "Messages preached during the 2026 conference.", items: sermons }), _jsx(MediaSection, { title: "Music Videos", description: "Choir, orchestra, and worship videos from the conference.", items: musicVideos })] })] }), _jsx(Footer, {})] }));
}
